

























import { listFactory } from '@/main/pages';
import { getSearchButtonLabel, isMultipleWorkshopSelected, handleMultiWorkshopFilter, getCurrentLanguageId, validateDateFields } from '@/main/utils/commonFunctions';

import { showAlert } from '@/main/utils/notifications';

import { NAME } from './constants';
import { store } from './store/list';
import { apiProvider } from './api';


export default listFactory(NAME, store).extend({
	data() {
		return {
			validateMessage: '',
			parameters: 'null' as string,
			selectedWorkshops: [] as number[],
			fromDate: 'DateFrom',
			toDate: 'DateTo',
		};
	},
	computed: {
		isMultipleWorkshopSelected(): boolean {
			return isMultipleWorkshopSelected(this.WorkshopIds);
		},
		searchButtonLabelKey(): string {
			return getSearchButtonLabel(this.WorkshopIds);
		},
	},
	methods: {
		async filterClick() {
			if (!validateDateFields(this, this.fromDate, this.toDate)) {
				return;
			}
			await handleMultiWorkshopFilter(
				this,
				NAME,
				this.WorkshopIds,
				(columnsSeq) => ({
					WorkshopIds: this.WorkshopIds,
					DateFrom: this.DateFrom,
					DateTo: this.DateTo,
					ColumnSequence: columnsSeq.join(','),
					LanguageId: getCurrentLanguageId(this.loggedUser.UzivatelData.LanguageId),
				}),
			);
		},
		dateValidation() {
			if (this.DateFrom && this.DateTo) {
				const fromDate = new Date(this.DateFrom);
				const toDate = new Date(this.DateTo);
				if (fromDate > toDate) {
					this.showErrorAlert({ message: this.LocalizePopisPoli('GREATER_DATE_VALIDATION') });
					this.DateFrom = null;
					this.DateTo = null;
					return false;
				}
				const milisecondPerDay = 1000 * 60 * 60 * 24;

				const utc1 = Date.UTC(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate());
				const utc2 = Date.UTC(toDate.getFullYear(), toDate.getMonth(), toDate.getDate());
				const dayDifference = Math.floor((utc2 - utc1) / milisecondPerDay);
				if (dayDifference > 365) {
					this.showErrorAlert({ message: this.LocalizePopisPoli('DP_365_DAY_DIFF') });
					this.DateFrom = null;
					this.DateTo = null;
					return false;
				}
				return true;
			}
			return false;
		},

		async exportFun() {
			try {
				if (this.filter.WorkshopIds == null || this.filter.WorkshopIds.length === 0) {
					this.showErrorAlert({ message: this.LocalizePopisPoli('DEALER_CODE_NOT_NULL') });
					return;
				}
				const columnsSeq = this.table.columns.filter(x => x.isVisible === true).map(x => x.columnName);
				this.startLoading();
				const urlParameters: string = this.GetParameters(this.WorkshopIds, this.DateFrom, this.DateTo);
				if (this.isMultipleWorkshopSelected) {
					this.showErrorAlert({
						message: this.LocalizeChyboveHlasky('MultiWorkshopExportDisabled'),
					});
				} else {
					await apiProvider.GetFullInventoryAdjustmentReport(urlParameters, columnsSeq, getCurrentLanguageId((this.loggedUser.UzivatelData.LanguageId)));
				}
			} catch (error) {
				showAlert({
					message: this.LocalizeChyboveHlasky('LocalMsg'),
					title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
					options: {
						type: 'error',
					},
				});
			} finally {
				this.endLoading();
			}
		},
		GetParameters(WorkshopIds : any, DateFrom : any, DateTo : any) {
			this.parameters = '';
			this.parameters = this.parameters.concat(`DateFrom=${new Date(DateFrom!).toISOString()}&DateTo=${new Date(DateTo).toISOString()}`);
			if (WorkshopIds.length > 0) {
				WorkshopIds.forEach((WorkshopId: any) => {
					this.parameters = this.parameters.concat(`&WorkshopIds=${WorkshopId}`);
				});
			}
			return this.parameters;
		},
	},

	mounted() {
		const element = document.getElementsByClassName('el-main');
		if (element.length != 0) element[0].classList.remove('d-flex');
	},
});
